import {
  NibbleCopyParams,
  NibbleCreateInCollectionParams,
  NibbleCreateParams,
  NibbleCut,
  NibbleEditCollRelatedNoteParams,
  NibbleGetModel,
  NibbleMoveParams,
  NibbleRemoveFromCollectionByIdParams,
  NibbleUpdateParams
} from '@aipb/gulliver/personal-content/model';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { NibbleApiService } from '../api';
import { FavoriteUserService } from './favorite-user';

@Injectable({
  providedIn: 'root'
})
export class FavoriteNibbleService {
  private _deletedFromCollection: Subject<any> = new Subject<any>();
  public deletedFromCollection$: Observable<any> = this._deletedFromCollection.asObservable();
  private _updateNibble = new Subject<void>();
  public updateNibble$ = this._updateNibble.asObservable();

  constructor(private api: NibbleApiService, private favoriteUserService: FavoriteUserService) {
  }

  public updateNibbleEvent() {
    this._updateNibble.next();
  }

  public create(nibble: NibbleCreateParams) {
    return this.api.create(nibble);
  }

  public createInCollection(nibble: NibbleCreateInCollectionParams, position: number) {
    return this.api.createInCollection({
      ...nibble,
      position: position
    });
  }

  public get(id: number): Observable<NibbleGetModel> {
    return this.api.get({
      id: id
    });
  }

  removeFromFavoriteCollectionByServiceValue(service: string, serviceValue: string) {
    return this.favoriteUserService.getInfo().pipe(
      mergeMap((data) => {
        return this.api.removeFromCollectionByServiceValue({
          service: service,
          serviceValue: serviceValue,
          uniqueId_coll: data.user.collections.favorites[0].id
        });
      })
    );
  }

  public changePosition(id: number, collectionId: string, newPosition: number, oldPosition: number) {
    return this.api.changePosition({
      id: id,
      collId: collectionId,
      newPosition,
      oldPosition
    });
  }

  public update(nibble: NibbleUpdateParams) {
    return this.api.update(nibble);
  }

  public editCollRelatedNote(params: NibbleEditCollRelatedNoteParams) {
    return this.api.editCollRelatedNote(params);
  }

  public copy(params: NibbleCopyParams) {
    return this.api.copy(params);
  }

  public move(params: NibbleMoveParams) {
    return this.api.move(params);
  }

  deleteFromCollection(nibbleCut: NibbleCut, collectionId: string) {
    const params: NibbleRemoveFromCollectionByIdParams = {
      id: [nibbleCut.nibble.id],
      collId: collectionId
    }

    if (nibbleCut.nibble.positionId) {
      params.positionId = [nibbleCut.nibble.positionId];
    }

    return this.api
      .removeFromCollectionById(params)
      .pipe(tap((data) => this._deletedFromCollection.next(data)));
  }
}
